const LOG_PREFIX = "[NDC scan]";

let constructStartMs: number | null = null;

export function markNdcConstructStart(): void {
  if (constructStartMs !== null) return;
  constructStartMs = performance.now();
   //console.log(`${LOG_PREFIX} construction started (first scanner key)`);
}

export function logNdcConstructed(ndc: string, source: string): void {
  const start = constructStartMs;
  if (start === null) return;

  const ms = Math.round(performance.now() - start);
  constructStartMs = null;
  // console.log(
  //   `${LOG_PREFIX} NDC constructed in ${ms} ms (${source}): ${ndc} — before fetchDrugDetails`
  // );
}

export function resetNdcConstructTiming(): void {
  constructStartMs = null;
}
